import StockoutListing from "./stockoutListing.container";

export default StockoutListing;
